import { z } from "zod";

// Pure Zod schemas safe to use client-side (no drizzle dependency)

export const insertMatchSchema = z.object({
  teamAPlayer1Id: z.string(),
  teamAPlayer2Id: z.string(),
  teamBPlayer1Id: z.string(),
  teamBPlayer2Id: z.string(),
  matchType: z.string().default("single_set_6"),
  clubId: z.string().nullable().optional(),
  isConfirmed: z.boolean().default(false).optional(),
  teamAConfirmedBy: z.string().nullable().optional(),
  teamAPlayer2ConfirmedBy: z.string().nullable().optional(),
  teamBConfirmedBy: z.string().nullable().optional(),
  teamBPlayer2ConfirmedBy: z.string().nullable().optional(),
  requiredConfirmers: z.array(z.string()).default([]).optional(),
});

export type InsertMatch = z.infer<typeof insertMatchSchema>;

export const insertClubSchema = z.object({
  name: z.string().min(1, "Name is required").max(25, "Le nom du club ne peut pas dépasser 25 caractères"),
  description: z.string().nullable().optional(),
  validationMethod: z.string().default("standard").optional(),
  newPlayerValidation: z.string().default("auto").optional(),
  eloStarting: z.string().default("standard").optional(),
  isVerified: z.boolean().default(false).optional(),
  archivedSeasons: z.array(z.any()).default([]).optional(),
});

export type InsertClub = z.infer<typeof insertClubSchema>;
